import { render, staticRenderFns } from "./CreateEventRefundPolicy.vue?vue&type=template&id=16deb1f4&scoped=true"
import script from "./CreateEventRefundPolicy.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEventRefundPolicy.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CreateEventRefundPolicy.vue?vue&type=style&index=0&id=16deb1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16deb1f4",
  null
  
)

export default component.exports